import { IAppAction } from "../appAction";
import { experimentsActions } from "./actions";
import { getDefaultExperimentsState, IExperimentsState } from "./state";
import { IExperimentList } from "services/types";

const handlers = {
  [experimentsActions.FETCH_EXPERIMENTS]: (
    state: IExperimentsState
  ): IExperimentsState => {
    return { ...state, loading: true, error: null };
  },

  [experimentsActions.FETCH_EXPERIMENTS_SUCCESS]: (
    state: IExperimentsState,
    data: IExperimentList,
  ): IExperimentsState => {
    return { ...state, loading: false, error: null, experiments: data };
  },

  [experimentsActions.FETCH_EXPERIMENTS_ERROR]: (
    state: IExperimentsState,
    error: Error,
  ): IExperimentsState => {
    return { ...state, loading: false, error: error, experiments: getDefaultExperimentsState()["experiments"] };
  },
};

export const experimentsReducer = (
  state: IExperimentsState = getDefaultExperimentsState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
